import { LOGOUT_ACTION, LogoutAction } from 'actions/authorization/logoutAction'
import {
  CLEAR_MAX_RATION_FEATURED_PHOTO,
  FeaturedPhotosAction,
  FETCH_ACTIVE_LIST_PHOTO,
  FETCH_ARCHIVE_FEATURED_PHOTO,
} from 'actions/featuredPhotosAction'
import { definitions } from 'api/generated/photorating'
import { defaultPromiseReducer } from 'reducers/defaultPromiseReducer'
import {
  FeaturedPhotosPopularityState,
  initialState,
  Status,
} from 'reducers/featuredPhotos/FeaturedPhotosPopularityState'

export const featuredPhotosPopularityReducer = (
  state = initialState,
  action: FeaturedPhotosAction | LogoutAction
): FeaturedPhotosPopularityState => {
  switch (action.type) {
    case FETCH_ACTIVE_LIST_PHOTO:
      return defaultPromiseReducer(
        state,
        action,
        undefined,
        (featuredPhotosList) => ({
          featuredPhotosList: deleteDuplicate(
            state.featuredPhotosList,
            featuredPhotosList
          ),
          loadedActivePhoto: true,
        })
      )

    case FETCH_ARCHIVE_FEATURED_PHOTO:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          archivedFeaturedPhoto: false,
        }),
        (maxRatioFeaturedPhoto) => ({
          maxRatioFeaturedPhoto: maxRatioFeaturedPhoto as unknown as number,
          archivedFeaturedPhoto: true,
          loadedActivePhoto: false,
          featuredPhotosList: state.featuredPhotosList.filter(
            ({ status }) => status !== Status.Inactive
          ),
        })
      )

    case CLEAR_MAX_RATION_FEATURED_PHOTO:
      return {
        ...state,
        maxRatioFeaturedPhoto: 0,
        archivedFeaturedPhoto: false,
      }

    case LOGOUT_ACTION:
      return defaultPromiseReducer(state, action, undefined, () => ({
        ...initialState,
      }))

    default:
      return state
  }
}

// Copy src/common/reducers/photosProfileReducer.ts: 139
// Нужно сделать через Generic
function deleteDuplicate(
  currentPhotosList: definitions['FeaturedPhoto'][],
  fetchPhotoList: definitions['FeaturedPhoto'][]
) {
  const mergeArray = [...currentPhotosList, ...fetchPhotoList]

  return mergeArray.reduce<definitions['FeaturedPhoto'][]>(
    (acc, currentItem) => {
      const findIndex = acc.findIndex(
        (item) => item.photoId === currentItem.photoId
      )
      if (findIndex === -1) {
        return acc.concat([currentItem])
      } else {
        const newAcc = [...acc]
        newAcc[findIndex] = currentItem
        return newAcc
      }
    },
    []
  )
}
